// extracted by mini-css-extract-plugin
export var container = "rea-module--container--628f7";
export var imageContainer = "rea-module--imageContainer--17eb5";
export var imageContainer1 = "rea-module--imageContainer1--87036";
export var items = "rea-module--items--3caf4";
export var text = "rea-module--text--e39e9";